/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer, VApplication } from '../../../../../application';
import { LoggerModule } from '@vlinder-web/logger-module-react';
import { ApplicationFormPageService } from '@/pages/ApplicationForm/services';

const MODULE_NAME = 'carricomApp.machines.states.getPage';
const log: any = LoggerModule?.getInstance();

const getSrv = () => {
  return vappContainer.get<ApplicationFormPageService>(
    ApplicationFormPageService.displayName
  );
};

export const carricomApp = async (context: any, event: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      log.blue(MODULE_NAME, 'context: ', context, 'event: ', event);
      const src = getSrv();
      console.log(event?.payload);
      const data: any = await src.agent.createCarricomApp(event?.payload);
      if (data) {
        return resolve({
          key: 'CREATE_APPLICATION_SUCCESS',
          value: {
            ...(data || {}),
          },
        });
      } else {
        return reject({
          key: 'CREATE_APPLICATION_SUCCESS',
          value: 'Invite Failed',
        });
      }
    } catch (err: any) {
      return reject({
        key: 'CREATE_APPLICATION_ERROR',
        value: err?.message,
      });
    }
  });
};
